import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { SingleReputationFragment } from '../../../../generated/graphql_offer';
import { SPACING_LARGE, SPACING_REGULAR, SPACING_UNIT } from '../../../constant/spacing';
import ReputationItem from './ReputationItem';

interface Props extends ClassAttributes<HTMLElement> {
  directorReputation: SingleReputationFragment;
  optimizerReputation: SingleReputationFragment | null;
  loadingReputation?: boolean;
  className?: string;
}

const ReputationDetail = ({ directorReputation, optimizerReputation, loadingReputation, className }: Props) => (
  <Root className={className}>
    <ReputationHeading variant="h6">
      <FormattedMessage id="reputation.review" />
    </ReputationHeading>
    <DirectorReputation reputation={directorReputation} loadingReputation={loadingReputation} />
    {optimizerReputation ? <OptimizerReputation reputation={optimizerReputation} /> : null}
  </Root>
);

const Root = styled('div')({
  marginBottom: SPACING_UNIT,
});

const ReputationHeading = styled(Typography)({
  marginBottom: SPACING_REGULAR,
});

const DirectorReputation = styled(ReputationItem)({});

const OptimizerReputation = styled(ReputationItem)({
  paddingLeft: SPACING_LARGE,
  marginTop: SPACING_REGULAR,
});

export default ReputationDetail;
